module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "368",
      "src": "images/f0016-01.jpg",
      "width": "550"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_vm._v("A STRANGER IN THE CANYON")])]), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("S")])]), _vm._v("TEPPING SOFTLY in the sand, the burro sneaked behind the prospector and playfully butted him up from his crouching position. The old man spun around, his face lighting with joy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Brighty!” he shouted happily. “You li’l ole pussyfooter! You eenamost upset the batter, to say nothing of me, myself.” He let the burro nuzzle his grizzly beard. “ ’Tain’t hay!” he howled with laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He laid more driftwood on the fire, then turned and began scratching Brighty, starting with the scruff of mane and kneading down the dark stripe along his back.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_vm._v("“Feller!” he thundered above the river’s roar. “You sure ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("got an alarum clock in your head! Tan my hide if you don’t arrive ’zactly at suppertime. It’s flapjacks tonight, see? Got the batter all done. Ain’t it nice and bubbly?”")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The burro began nosing the batter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no, you don’t!” The old man pushed the burro’s face out of the bowl. “You just wait till I flap ’em. Me and you’s goin’ to celebrate tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He spooned lard into the skillet, and while it was melting pulled some blue-flecked stones from his pocket and held them under Brighty’s nose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sniff ’em!” he urged. “Sniff ’em good. Where they come from, they’s more—a hull bluish-green vein o’ the stuff. And if I could just find somebody to help dig it up, then me and you could pack it out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The burro’s ears swung back and forth, asking for more talk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yup, Bright Angel, you and me’s struck it rich. We’ve found us enough copper ore to last till kingdom come, and mebbe after!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He took off his black hat and let the wind comb his hair. “We’ll call our diggings the ‘Little Mimi’ for my sister’s gal. It’s like this, Brighty,” he explained as he stooped to pick up a fallen blue jay’s feather. “My kid sister had only the one gal, Mimi, and she’s crippled in the legs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He stuck the feather in his hatband and smoothed it out. “Mimi’s purty as an angel—eyes blue as lupine and curls the color o’ wood shavings. Now, Brighty,” he said, his face shining with plans, “with the money from the ore, we’ll buy her a wheel chair so she can go scootin’ through life like a butterfly.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("He paused to add more lard to the skillet. “As fer ye, young ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("feller, when the money rolls in, I’ll buy ye all kinds o’ doodads—a tinkly bell for your neck and a shade-hat with holes for yer ears, and some flea-shoo powder, and . . .”")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Brighty wheeled around, looking, smelling, listening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey! Hark to me instead o’ the night noises. It’s just the river sawin’ away at the rocks, or some old coyote tunin’ up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the burro’s ears were prying into the night and his breath snorting in his nose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Humph, don’t hear a thing myself.” The old man poured two mounds of batter into the skillet. “Could be our ring-tail cat sharpenin’ her toenails on a piece of drift,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then all at once the prospector caught movement. The tall figure of a man loomed in the dark. He stalked slowly toward the fire, a dead beaver dangling from one hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Reckon I skeered you,” the man grunted. His voice sounded rusty, as if it had not been used for a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The prospector stroked the burro’s neck, trying to quiet him. “Brighty here told me you was comin’, but I wouldn’t believe him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Motionless except for his fingers twirling the beaver, the stranger sized up the prospector. Then his eyes looked past him to the tent, where a pick and a pan stood outlined against the white canvas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sweet smell of hot cakes filled the air and the old man dropped a third spoonful of batter on the skillet. “In the shock o’ seein’ a human being,” he said, “I mighty near forgot to cook for three mouths ’stead o’ two. Would you believe it, stranger, I ain’t seen a livin’ soul ’cept Uncle Jimmy Owen and Brighty here for upwards o’ six month? I’m mighty glad to meet you.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c37972e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 75
// module chunks = 0